import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import HomeContent from '../Components/HomeContent/HomeContent'
import Category from '../Components/Category/Category'
import Arrivals from '../Components/Arrivals/Arrivals'
import Gifts from '../Components/Gifts/Gifts'
import PlantsCategory from '../Components/PlantsCategory/PlantsCategory'
import About from '../Components/About/About'
import Album from '../Components/Album/Album'
import Reviews from '../Components/Reviews/Reviews'
import Footer from '../Components/Footer/Footer'
const Home = () => {
  return (
    <div>
          <div className="App">
      <header className="App-header position-relative">
        <NavBar />
        <HomeContent />
      </header>
      <Category />
      <Arrivals />
      <Gifts />
      <PlantsCategory />
      <About />
      <Album />
      <Reviews />
      <Footer />
    </div>
    </div>
  )
}

export default Home
